import * as React from "react";
function SvgZoomOrigin(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M2 30h10v2H0V0h12v2H2v28zM30 2H20V0h12v32H20v-2h10V2zm-7 14a7 7 0 01-14 0 7 7 0 0114 0zm-2 0a5 5 0 00-10 0 5 5 0 0010 0z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgZoomOrigin);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
